import { fromJS, Map } from 'immutable'
import { LOGOUT } from '../authentication/constants'
import * as actionTypes from './constants'
import { setTaskStates } from '../../utils/setTaskState'

const initialState = fromJS({
  projectTasks: {}
})

function taskListReducer(state = initialState, action) {
  let projectTasksPage = null
  if (state.hasIn(['projectTasks', action.page])) {
    projectTasksPage = state.getIn(['projectTasks', action.page])
  }

  switch (action.type) {
    case actionTypes.GET_PROJECT_TASKS:
      return state.set('loadingProjectTasks', true)
    case actionTypes.CLEAR_PROJECT_TASKS:
      return state.set('projectTasks', new Map())
    case actionTypes.GET_PROJECT_TASKS_DONE: {
      const content = action.tasks.content.map(setTaskStates)

      return state
        .set('loadingProjectTasks', false)
        .setIn(['projectTasks', action.page], { ...action.tasks, content })
    }

    case actionTypes.GET_ALL_PROJECT_TASKS: {
      return state.set('gettingAllProjectTasks', true)
    }
    case actionTypes.GET_ALL_PROJECT_TASKS_DONE: {
      return state
        .set('allProjectTasksDone', action.allProjectTasks)
        .set('gettingAllProjectTasks', false)
    }
    case actionTypes.GET_ALL_PROJECT_TASKS_ERROR: {
      return state.set('gettingAllProjectTasksError', action.error)
    }

    case actionTypes.GET_PROJECT_TASKS_ERROR:
      return state
        .set('loadingProjectTasks', false)
        .set('getProjectTasksError', action.error)

    // update tasks batch
    case actionTypes.UPDATE_TASKS_BATCH:
      return state.set('updatingTasksBatch', true)
    case actionTypes.UPDATE_TASKS_BATCH_DONE:
      action.keys.forEach((key, index) => {
        const newTask = action.tasks[index]
        if (!newTask.done) {
          newTask.doneSince = undefined
        }
        const updatedNewTask = setTaskStates(newTask)
        projectTasksPage.content[key] = {
          ...projectTasksPage.content[key],
          ...updatedNewTask
        }
      })
      return state
        .setIn(['projectTasks', action.page], projectTasksPage)
        .set('updatingTasksBatch', false)
    case actionTypes.UPDATE_TASKS_BATCH_ERROR:
      return state
        .set('updateTasksBatchError', action.error)
        .set('updatingTasksBatch', false)

    case actionTypes.UPDATE_BULK_TASKS:
      return state.set('updatingBulkTasks', true)
    case actionTypes.UPDATE_BULK_TASKS_DONE:
      return state.set('updatingBulkTasks', false)
    case actionTypes.UPDATE_BULK_TASKS_ERROR:
      return state
        .set('updatingBulkTasks', false)
        .set('updateBulkTasksError', action.error)

    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default taskListReducer
